import React, { Component } from "react";
import Skeleton from "react-loading-skeleton";
import _ from "lodash";
import { Modal, Button } from "react-bootstrap";
import DetailItem from "../../../components/detailItem";
import textFormatService from "../../../services/utility/textFormatService";

interface IDataProviderReportDetailProps {
  showDetailsModal: boolean;
  toggleDetailsModal: any;
  item: any;
}

interface IDataProviderReportDetailState {
}

class DataProviderReportDetail extends Component<
  IDataProviderReportDetailProps,
  IDataProviderReportDetailState
> {
  constructor(props: IDataProviderReportDetailProps) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { showDetailsModal, toggleDetailsModal, item } = this.props;
    return (
      <Modal
        size="xl"
        backdrop="static"
        show={showDetailsModal}
        onHide={toggleDetailsModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {_.isEmpty(item) ? (
              <Skeleton width={500} />
            ) : (
              <h5>
                <i className="fas fa-receipt fa-sm s-18 mr-3" />
                Data Provider Report Detail
              </h5>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card">
            <div className="card-header clear-fix">
              {_.isEmpty(item) ? (
                <Skeleton width={200} />
              ) : (
                <h6
                  className="card-title float-left"
                  style={{ marginBottom: "0px" }}
                >
                  <b>General Information</b>
                </h6>
              )}
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  {_.isEmpty(item) ? (
                    <Skeleton count={8} width={300} />
                  ) : (
                    <dl className="row">
                      <DetailItem
                        label="Institution Name"
                        value={item.institutionName}
                        labelSize={4}
                        valueSize={8}
                      />
                      <DetailItem
                        label="Name"
                        value={item.name}
                        labelSize={4}
                        valueSize={8}
                      />
                      <DetailItem
                        label="Customer Info"
                        value={item.customerInfo}
                        labelSize={4}
                        valueSize={8}
                      />
                      <DetailItem
                        label="Response"
                        value={item.response}
                        labelSize={4}
                        valueSize={8}
                      />
                    </dl>
                  )}
                </div>
                <div className="col-md-6">
                  {_.isEmpty(item) ? (
                    <Skeleton count={8} width={300} />
                  ) : (
                    <dl className="row">
                      <DetailItem
                        label="Institution Code"
                        value={item.institutionCode}
                        labelSize={4}
                        valueSize={8}
                      />
                      <DetailItem
                        label="Provider"
                        value={item.provider}
                        labelSize={4}
                        valueSize={8}
                      />
                      <DetailItem
                        label="Date Created"
                        value={textFormatService.formatTimeString(item.dateCreated)}
                        labelSize={4}
                        valueSize={8}
                      />
                    </dl>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            size="sm"
            variant="outline-danger"
            onClick={toggleDetailsModal}
          >
            <i className="fas fa-times mr-3" />
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default DataProviderReportDetail;
